import { createReducer, on } from '@ngrx/store';

import { ItemLocalization, Language } from '../../classes/language.class';
import { LangRouteString } from '../../enums/route-string';
import * as actions from '../actions/languages.actions';
import { featureKey, initialState, IState, itemLocalizationAdapter, languagesAdapter } from '../states/languages.state';

export { featureKey, IState };

export const reducer = createReducer(
  initialState,
  on(actions.SET_LANG, (state, { language }) => ({
    ...state,
    langs: {
      ...state.langs,
      selected: Object.values(LangRouteString).some((x) => x === language) ? language! : 'en',
    },
  })),
  on(actions.GET_LANG_COMMAND, (state) => ({
    ...state,
    langs: {
      ...state.langs,
      isLoading: true,
    },
  })),
  on(actions.GET_LANG_SUCCESS, (state, { languages }) => ({
    ...state,
    langs: {
      ...languagesAdapter.setAll(
        languages.map((x) => new Language(x)),
        state.langs,
      ),
      isLoading: false,
    },
  })),
  on(actions.GET_LACALIZATION_COMMAND, (state) => ({
    ...state,
    localization: {
      ...state.localization,
      isLoading: true,
    },
  })),
  on(actions.GET_LACALIZATION_SUCCESS, (state, { items }) => ({
    ...state,
    localization: {
      ...itemLocalizationAdapter.setAll(
        items.map((x) => new ItemLocalization(x)),
        state.localization,
      ),
      isLoading: false,
    },
  })),
  on(actions.TOGGLE_DEV_MODE, (state) => ({
    ...state,
    localization: {
      ...state.localization,
      dev: typeof state.localization.dev === 'boolean' ? !state.localization.dev : true,
    },
  })),
);

const languagesSelectors = languagesAdapter.getSelectors();

export const selectLanguagesIds = languagesSelectors.selectIds;
export const selectLanguagesEntities = languagesSelectors.selectEntities;
export const selectAllLanguages = languagesSelectors.selectAll;
export const selectLanguagesTotal = languagesSelectors.selectTotal;

const localizationSelectors = itemLocalizationAdapter.getSelectors();

export const selectLocalizationIds = localizationSelectors.selectIds;
export const selecLocalizationEntities = localizationSelectors.selectEntities;
export const selectAllLocalization = localizationSelectors.selectAll;
export const selectLocalizationTotal = localizationSelectors.selectTotal;
